import { Component, Input } from "@angular/core";

@Component({
  selector: "app-entity-not-found",
  templateUrl: "./entity-not-found.component.html",
  styleUrls: ["./entity-not-found.component.css"],
})
export class EntityNotFoundComponent {
  @Input() public resource: string = "Resource";
  @Input() public id: string;
  @Input() public backTo: string = "/services";
  @Input() public backLabel: string = "Back to services";
  // Second hint line. Pass "" from the wildcard 404 case, where "pick another"
  // reads oddly because there is no list to pick from.
  @Input() public hintSuffix: string = "Pick another one to continue.";

  public copied: boolean = false;

  public get resourceLabel(): string {
    // "This Service" reads awkwardly mid-sentence; lowercase the parameter
    // so it composes as natural prose: "We couldn't find this service".
    return (this.resource || "resource").toLowerCase();
  }

  public copyLink(): void {
    if (typeof navigator === "undefined" || !navigator.clipboard) {
      return;
    }
    navigator.clipboard.writeText(window.location.href).then(
      () => {
        this.copied = true;
        setTimeout(() => (this.copied = false), 2000);
      },
      () => {
        // Clipboard permission denied — silently ignore; user can copy manually.
      },
    );
  }
}
